import { useState, useEffect } from "react";
import { httpService } from "../services/httpService.service";

export const useCountriesAndData = (form) => {
   const [countries, setCountries] = useState([]);
   const [selectedCountry, setSelectedCountry] = useState(null);
   const [states, setStates] = useState([]);

   useEffect(() => {
      let isMounted = true;

      const fetchCountries = async () => {
         const url = `/Languages/getAllCountries`;
         try {
            const res = await httpService.get(url);
            if (isMounted) {
               setCountries(
                  res.data
                     .map((item) => ({
                        id: item.id,
                        name: item.name,
                        role: item.code
                     }))
                     .sort((a, b) => a.name.localeCompare(b.name))
               );
            }
         } catch (error) {
            console.log(error);
         }
      };

      fetchCountries();

      return () => {
         isMounted = false;
      };
   }, []);

   const handleCountryChange = async (selectedOption, formFields) => {
      setSelectedCountry(selectedOption.role);
      console.log("formFields:", formFields);
      form.setFieldsValue(formFields);

      var headers = new Headers();
      headers.append("X-CSCAPI-KEY", process.env.REACT_APP_COUNTRY_STATE_CITY_API_KEY);

      var requestOptions = {
         method: "GET",
         headers: headers,
         redirect: "follow"
      };

      try {
         const response = await fetch(
            `https://api.countrystatecity.in/v1/countries/${selectedOption.role}/states`,
            requestOptions
         );
         const parseData = await response.json();
         let filteredStates = parseData;

         setStates(
            filteredStates
               .map((item) => ({
                  id: item.id,
                  name: item.name,
                  role: item.iso2
               }))
               .sort((a, b) => a.name.localeCompare(b.name))
         );
      } catch (error) {
         console.log("error", error);
      }
   };

   return { countries, selectedCountry, states, handleCountryChange };
};
